const PREFIX = 'VISIT_LOG_';

export const GET_VISITS = `${PREFIX}GET`;
export const SET_VISITS = `${PREFIX}SET`;
export const DOWNLOAD_VISITS = `${PREFIX}DOWNLOAD_VISITS`;
